import { render } from "./ModalMP.vue?vue&type=template&id=6f658f60&scoped=true"
import script from "./ModalMP.vue?vue&type=script&lang=js"
export * from "./ModalMP.vue?vue&type=script&lang=js"

import "./ModalMP.vue?vue&type=style&index=0&id=6f658f60&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\apontamentowebvueV3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f658f60"]])

export default __exports__